// @flow
import { connect } from 'react-redux';

import RencontreGeneralLive, {
  type StateProps,
  type DispatchProps
} from 'components/rencontre/general/RencontreGeneralLive';

import { setRencontre } from 'actions/rencontreActions';

import type { RencontreActionContainerType } from 'types/Rencontre';
import type { StateType, DispatchType } from 'types/Actions';

const mapStateFromProps = (state: StateType): StateProps => ({
  rencontre: state.rencontreState.rencontre,
});

const mapDispatchToProps = (dispatch: DispatchType ): DispatchProps => ({
  setRencontre: (actions: RencontreActionContainerType[]) => dispatch(setRencontre(actions)),
});

export default connect(mapStateFromProps, mapDispatchToProps)(RencontreGeneralLive);
